"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
/**
 * Handle protected downloads
 *
 * @namespace
 * @memberOf txGs1Base
 * @public
 */
const _main_1 = require("./_main");
_main_1.txGs1Base.protectedDownloads = {
    initialize: function () {
        'use strict';
        $('a.protected-download-link').prop({
            'rel': 'contentbox'
        });
    }
};
exports.default = {};
